<template>
  <div>
    <div class="m_context plr">
    <el-row>

      <el-col :span="24">
        <el-form ref="addForm" id="addForm" :model="form" :rules="rules" label-width="12.5%">

          <el-form-item :label="$t('lin_global.certificateName')" prop="certificateName">
            <el-input id="userName" v-model="form.certificateName" :placeholder="$t('lin_global.bitian')"></el-input>
          </el-form-item>

          <el-form-item :label="$t('lin_global.guojia')" prop="country">
            <el-input id="nickName" v-model="form.country" :placeholder="$t('lin_global.guojiatips')"></el-input>
          </el-form-item>

          <el-form-item :label="$t('lin_global.shengfen')" prop="province">
            <el-input id="phoneNum" v-model="form.province" :placeholder="$t('lin_global.shenfentips')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lin_global.city')" prop="city">
            <el-input id="phoneNum" v-model="form.city" :placeholder="$t('lin_global.cityTips')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lin_global.gongsi')" prop="company">
            <el-input id="phoneNum" v-model="form.company" :placeholder="$t('lin_global.gongsiTips')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lin_global.youxiang')" prop="email">
            <el-input id="phoneNum" v-model="form.email" :placeholder="$t('lin_global.emailTips')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lin_global.youxiaoqi')" prop="termTime">
            <el-input id="phoneNum" v-model="form.termTime" :placeholder="$t('lin_global.youxiaoqiTips')">
              <template slot="append">{{$t('lin_global.danweitian')}}</template>
            </el-input>
            <!--<span style="position: absolute;right: -80px;top: 2px;">{{$t('lin_global.danweitian')}}</span>-->
          </el-form-item>

          <!-- =========-->
          <!-- 证书类型： 1： 客户，2： 厂商-->
          <!-- =========-->
          <el-form-item :label="$t('lin_global.certTypeLabel')" v-if='showsManufacturerCert' required>
            <el-radio-group v-model="form.certificateType">
              <el-radio :label="'1'" >{{$t('lin_global.certForCustomer')}}</el-radio>
              <el-radio :label="'2'">{{$t('lin_global.certForManufacturer')}}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item :label="$t('lin_global.label_areaid')" prop="distributorId" v-if="form.certificateType == 1">
            <!--<el-select id="mechanismId" v-model="form.distributorId" filterable clearable :placeholder="$t('lin_global.place_areaid')" class="w_33">-->
              <!--<el-option v-for="item in areaList" :label="item.mechanismname" :value="item.mechanismid">-->
              <!--</el-option>-->
            <!--</el-select>-->
            <MechanismSelector :data="mechanismData" :mselect="true" :classs="'w_33'"></MechanismSelector>
          </el-form-item>
          <el-form-item :label="$t('lin_global.remark')">
            <el-input v-model="form.certificateDesc" :placeholder="$t('lin_global.xuantian')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="onCancel" id="onCancel">{{$t('lin_btn.cancel')}}</el-button>
            <el-button type="primary" :loading="isSubmit" @click="onSubmit">{{$t('lin_global.xinjian')}}</el-button>
          </el-form-item>

        </el-form>
      </el-col>

    </el-row>

    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import { baseurl } from '../../api/url'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    computed: {
      showsManufacturerCert: function () {
        return localStorage.userType === '0'
      }
    },
    components: {
      MechanismSelector
    },
    data(){
      var emailCheck = (rule, value, callback) => {
        var rg =  /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        if(!(rg.test(value))){
          callback(new Error(this.$t('lin_global.srgsbzq')));
        }else{
          callback();
        }
      };
      var numCheck = (rule, value, callback) => {
        var rg = /^([1-9]\d*|0)(\.\d*[1-9])?$/;
        if(!(rg.test(value))){
          callback(new Error(this.$t('lin_global.srgsbzq')));
        }else{
          callback();
        }
      };
      var zimuCheck = (rule, value, callback) => {
        var rg = /^[A-Za-z]+$/;
        if(!(rg.test(value))){
          callback(new Error(this.$t('lin_global.srgsbzq')));
        }else{
          callback();
        }
      };
      var that = this
      return{
        mechanismData: {
          placeholder: that.$t('lin_global.place_areaid'),
          callback (value) {
            that.form.distributorId = value
//            that.statusChange(value)
          }
        },
        isSubmit: false,
        dialogFormVisible: false,
        formLabelWidth: '100px',
        loading: true,
        form:{
          certificateName:'',
          certificateDesc:'',
          distributorId:'',
          country:'',
          province:'',
          city:'',
          company:'',
          email:'',
          termTime:'',
          certificateType: '1'
        },

        rules:{
          'certificateName':[{
            required: true,
            message: this.$t('lin_global.notNull')
          }],
          'distributorId':[{
            required: true,
            message: this.$t('lin_global.notNull')
          }],
          'country':[{
            required: true,
            message: this.$t('lin_global.notNull')
          },{
            validator: zimuCheck, trigger: 'blur'
          }],
          'province':[{
            required: true,
            message: this.$t('lin_global.notNull')
          },{
            validator: zimuCheck, trigger: 'blur'
          }],
          'city':[{
            required: true,
            message: this.$t('lin_global.notNull')
          },{
            validator: zimuCheck, trigger: 'blur'
          }],
          'company':[{
            required: true,
            message: this.$t('lin_global.notNull')
          },{
            validator: zimuCheck, trigger: 'blur'
          }],
          'email':[{
            required: true,
            message: this.$t('lin_global.notNull')
          },{
            validator: emailCheck, trigger: 'blur'
          }],
          'termTime':[{
            required: true,
            message: this.$t('lin_global.notNull')
          },{
            validator: numCheck, trigger: 'blur'
          }]
        },
        areaList:[],
        roleList:[]
      }
    },
    created(){
//      this.getAd();
      this.getRole();

    },
    methods:{
      isLegalMobile (tel) {
        var sMobile = tel
        var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$"
        var re = new RegExp(regex, 'g')
        if(!(re.test(sMobile))){
          return false
        } else {
          return true
        }
      },
      chang:function(){
        //alert("nime")
        this.dialogFormVisible = true
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var params = {
                userId:this.$route.params.id,
                oldPwd:this.$sha256(this.formPwd.oldPass),
                newPwd:this.$sha256(this.formPwd.checkPass)
            }
            //console.log("打印修改密码传参")
            //console.log(params);
            axios.post(`${baseurl}/user/updatePassword.do`,params).then(res=>{
              //console.log("打印看看登陆信息")
              //console.log(res.data);
              if(res.data.status == 200){
                this.dialogFormVisible = false;
                this.$message.success(res.data.message);

              }else{
                this.dialogFormVisible = false;
                this.$message.error(res.data.message)
              }
            })
          } else {
            //console.log('error submit!!');
            return false;
          }
        });
      },

      addInfo:function(){
        if (this.form.certificateType == 2) {
            this.form.distributorId = "";
        }
        var params = this.form;
        //console.log("打印传入参数");
        //console.log(params)
        this.isSubmit = true;
        axios.post(`${baseurl}/cer/add.do`,params).then(res=>{
          //console.log("打印看看登陆信息")
          //console.log(res.data);
          if(res.data.status == 200){
            this.$message.success(res.data.message);
            this.isSubmit = false;
            this.$router.go(-1);
          }else{
            this.isSubmit = false;
            this.$message.error(res.data.message)
          }
        })
      },

      onSubmit:function(){
        this.$refs['addForm'].validate((valid)=>{
          if(valid){
            this.addInfo()
          }else{
            this.$message.error(this.$t('lin_global.refs'))
            return false
          }
        })
      },
      getAd:function(){
        var params = {page:1,rows:10000};
        axios.post(`${baseurl}/mechanism/list.do`,params).then(res=>{
          this.areaList = res.data.data;
        })
      },
      getRole:function(){
        var mechanismId = localStorage.getItem('mechanismId');
        var params = {page:1,rows:10000,distributorid:mechanismId};
        axios.post(`${baseurl}/role/list.do`,params).then(res=>{
          this.roleList = res.data.data;
        })
      },
      onCancel:function(){
        this.$router.go(-1);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// certNew.vue?6ed2e92f